define('app/form',['jquery-placeholder'], function() {

	return Backbone.View.extend({

		xhr: null,

    xhrUpload: null,

    files: [],

		events: {
			'click .submit' : 'onClickSubmit',
      'change select': 'onChangeSelect',
      'change [type="date"]': 'onChangeDate'
		},

		initialize: function(options) {
      Backbone.View.prototype.initialize.call(this, options);
      _.bindAll(this, 'onClickSubmit', 'onSubmit', 'onSubmitSuccess', 'onSubmitError');

      $('input[type="text"],input[type="email"],textarea', this.$el).each(function(){
        $(this).placeholder();
        var mask = $(this).data('mask');
        if(mask) $(this).mask(mask);
      });

      if(!isMobile.any) {
        $('select', this.$el).each(function () {
          $(this).select2({
            minimumResultsForSearch: 10,
            matcher: function (term, text) {
              //change to >= 0 for %like% type search
              return text.toUpperCase().indexOf(term.toUpperCase()) >= 0;
            }
          });
        });
      }

      if(!isMobile.phone){
        $('.datepicker', this.$el).datepicker(options.datepicker || {});
      }

			if(this.$el.hasClass('parsley')){
				this.$el.parsley(options.parsley);
			}

      if(this.$el.hasClass('ajax')){
        this.events['submit'] = this.onSubmit;
        this.delegateEvents();
      }
		},

    onChangeSelect: function(e){
      var selected = $(e.currentTarget).prop('selectedIndex') == 0;
      $(e.currentTarget).toggleClass('empty', selected).select2('container').toggleClass('empty', selected);
    },

    onChangeDate: function(e){
      $(e.currentTarget).toggleClass('empty', $(e.currentTarget).val() == '');
    },

		onClickSubmit: function(e){
			this.$el.submit();
		},

		onSubmit: function(e){
			var valid = true;

			if(this.$el.hasClass("submitting")){
				valid = false;
			}

			if(this.$el.hasClass('parsley')){
				valid = this.$el.parsley('validate');
			}

      if(this.$el.find('.upload-progress').length){
        valid = false;
      }

			if(!valid){
				return false;
			}

			if(this.$el.hasClass('ajax')){
				if(this.xhr) this.xhr.abort();

				this.xhr = $.ajax({
					url: this.$el.data("action"),
					type: this.$el.data("method") || "post",
					dataType: 'json',
					data: this.$el.serialize(),
					success: this.onSubmitSuccess,
					error: this.onSubmitError
				});

			} else {
				this.$el.submit();
			}

			//add submitting class to prevent double submits
      this.$el.addClass("submitting");

			e.preventDefault();
			return false;
		},

		onSubmitSuccess: function(response, textStatus, jqXHR){
			this.$el.removeClass('submitting');

			if(response.success){
        this.$el.get(0).reset();
        $('input,select,textarea').each(function(){
          $(this).trigger('change').trigger('blur');
        });
        var parsley = this.$el.data().Parsley;
        if(parsley){
          parsley.reset();
        }
        var _self = this;
        $('.hide-after-success', this.$el).fadeOut(function(){
          $('.show-after-success', _self.$el).fadeIn();
        });
        this.trigger('success', response, this.$el);
			} else {
        this.trigger('error');
        alert(response.message, response, this.$el);
      }
		},

		onSubmitError: function(jqXHR, textStatus, errorThrown){
			this.$el.removeClass('submitting');
      this.trigger('failure');
		}

	});

});
